import ApiPermisos from '../../services/apiPermisos'

export default {
  namespaced: true,
  state: {
    errorMsj: '',
    loading: false,
    loadingFile: false,
  },
  getters: {

    getErrorMsj (state){
      return state.errorMsj;
    },

    getLoading (state){
      return state.loading;
    },

    getLoadingFile (state){
      return state.loadingFile;
    }

  },


  mutations: {

    setErrorMsj: (state, loading) => {
      state.errorMsj = loading;
    },

    setLoading: (state, loading) => {
      state.loading = loading;
    },

    setLoadingFile: (state, loading) => {
      state.loadingFile = loading;
    },
  
  },


  actions: {    
    // Guardar archivo
    actSaveFileSiesa: async ({
      commit
    }, data) => {
      commit('setLoadingFile', true);
      // Guardar archivo
      let response = await ApiPermisos.saveFileSiesa(data);
      commit('setLoadingFile', false);
      if (response.error) {
        commit('setErrorMsj', response);
        return response.error;
      }else{
        return response;
        
      }
    },  

    actSetMsg: async ({
      commit
    }, data) => {
      commit('setErrorMsj', data);
    },  
    
  },
}